var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[(
        (_vm.showSkeleton ||
          (_vm.saleUninitiated && !_vm.$route.query.listar_apresentacoes)) &&
          !_vm.showQueue &&
          !_vm.showPreSale
      )?_c('v-flex',{attrs:{"xs12":""}},[_c('skeleton')],1):_vm._e(),(
        !_vm.showDefault &&
          _vm.sectorMap &&
          _vm.sectorMap.length > 0 &&
          (!_vm.$route.query.listar_apresentacoes ||
            !_vm.filteredPresentations.length) &&
          !_vm.showQueue &&
          !_vm.showPreSale
      )?_c('v-flex',{class:_vm.selectedSeat || _vm.selectedInfo ? 'md8' : '',attrs:{"xs12":""}},[_c('SeatMap')],1):_vm._e(),(
        !_vm.showDefault &&
          _vm.selectedSeat &&
          !_vm.selectedSeat.reserved &&
          !_vm.showQueue &&
          !_vm.showPreSale
      )?_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('ProductsSector')],1):_vm._e(),(
        !_vm.showDefault &&
          _vm.selectedInfo &&
          !_vm.showSkeleton &&
          !_vm.showQueue &&
          !_vm.showPreSale
      )?_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('Info')],1):_vm._e(),(!_vm.showDefault && _vm.selectedSeat && _vm.selectedSeat.reserved)?_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('EditProductsSector')],1):_vm._e(),(!_vm.orderPdvExpired && !_vm.showPreSale && !_vm.showQueue)?_c('v-flex',{style:(_vm.currentStep === 5 &&
        _vm.orderData &&
        _vm.orderData.orderData &&
        _vm.orderData.orderData.gamification
          ? 'height: 100% !important'
          : ''),attrs:{"xs12":"","md6":""}},[(_vm.currentStep === 1 && _vm.showDefault && !_vm.showSkeleton && _vm.eventMapUrl)?_c('Map',{attrs:{"mapUrl":_vm.eventMapUrl}}):(
          _vm.showDefault &&
            !_vm.showSkeleton &&
            !_vm.printTickets &&
            !_vm.saleUninitiated &&
            !_vm.$route.query.listar_apresentacoes
        )?_c('Summary'):_vm._e(),(
          _vm.currentStep === 5 &&
            _vm.orderData &&
            _vm.orderData.orderData &&
            _vm.orderData.orderData.gamification
        )?_c('Gamification'):_vm._e()],1):_vm._e(),(
        _vm.showDefault &&
          !_vm.showSkeleton &&
          !_vm.orderPdvExpired &&
          !_vm.showPreSale &&
          !_vm.showQueue &&
          !_vm.saleUninitiated &&
          (!_vm.$route.query.listar_apresentacoes || !_vm.filteredPresentations.length)
      )?_c('v-flex',{class:_vm.printTickets && _vm.currentComponent.name === 'Confirmation'
          ? 'md12'
          : 'md6',attrs:{"xs12":""}},[_c('keep-alive',[_c(_vm.currentComponent.name,_vm._b({tag:"component"},'component',_vm.currentComponent.props,false))],1)],1):_vm._e(),(
        _vm.currentStep === 1 &&
          _vm.$route.query.listar_apresentacoes &&
          !_vm.showSkeleton &&
          _vm.filteredPresentations.length
      )?_c('v-flex',{staticClass:"xs12"},[_c('choose-presentation',{attrs:{"filteredPresentations":_vm.filteredPresentations}})],1):_vm._e(),(
        _vm.currentStep === 1 &&
          _vm.cartProducts.length &&
          !_vm.selectedSeat &&
          !_vm.saleUninitiated
      )?_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-divider'),_c('products-pre-order')],1)],1):_vm._e(),(_vm.showPreSale)?_c('v-flex',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('pre-sale')],1)],1)],1):(_vm.showQueue && _vm.queue)?_c('v-flex',[_c('v-layout',{attrs:{"row":!_vm.mobile ? true : false,"column":_vm.mobile ? true : false}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('queue')],1),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":"","xl6":""}},[_c('queue-information')],1)],1)],1):_vm._e(),(_vm.orderPdvExpired)?_c('v-flex',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","lg12":"","xl12":""}},[_c('order-expired')],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }